import Layout from 'components/Layout';

import Instructions from './index';

const AppInstructionsPage = () => {
  return (
    <Layout>
      <Instructions />
    </Layout>
  );
};

export default AppInstructionsPage;
